<template>
  <div class="fee-dashboard-container bg-white">
    <div class="index-title">
      <span>{{ $t('propertyIndex.feeDashboard') }}</span>
      <span class="month-label">{{ feeDashboard.monthLabel }}</span>
    </div>

    <el-row :gutter="12" class="summary-row">
      <el-col v-for="item in summaryStats" :key="item.key" :xs="24" :sm="8" :md="8" :lg="8">
        <div class="summary-card" :class="item.className">
          <div class="summary-label">{{ $t(`propertyIndex.${item.label}`) }}</div>
          <div class="summary-amount">¥{{ formatAmount(item.value) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="12" class="fee-item-row">
      <el-col v-for="item in feeItems" :key="item.key" :xs="24" :sm="12" :md="8" :lg="4">
        <div class="fee-item-card">
          <div class="fee-item-icon">
            <i :class="item.icon"></i>
          </div>
          <div class="fee-item-name">{{ $t(`propertyIndex.${item.label}`) }}</div>
           <div class="fee-item-amount">¥{{ formatAmount(item.receivableAmount) }}</div>
           <div class="fee-item-percent">
             {{ $t('propertyIndex.receivablePercent') }} {{ formatPercent(item.receivablePercent) }}
           </div>
          <div class="fee-item-desc">
            {{ $t('propertyIndex.unreceived') }}：¥{{ formatAmount(item.unreceivedAmount) }}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getFeeDashboardIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexFeeDashboard',
  data() {
    return {
      feeDashboard: {
        monthLabel: '',
        summary: {
          todayReceivedAmount: 0,
          receivableAmount: 0,
          unreceivedAmount: 0,
          historyOweAmount: 0
        },
        feeItems: []
      },
      defaultFeeItems: [
        { key: 'propertyFee', label: 'propertyFee', icon: 'el-icon-office-building' },
        { key: 'historyOweFee', label: 'historyOweFee', icon: 'el-icon-warning-outline' },
        { key: 'electricFee', label: 'electricFee', icon: 'el-icon-lightning' },
        { key: 'waterFee', label: 'waterFee', icon: 'el-icon-cold-drink' },
        { key: 'multiBusinessFee', label: 'multiBusinessFee', icon: 'el-icon-s-operation' },
        { key: 'parkingMonthlyFee', label: 'parkingMonthlyFee', icon: 'el-icon-truck' }
      ]
    }
  },
  computed: {
    summaryStats() {
      return [
        {
          key: 'todayReceivedAmount',
          label: 'todayReceived',
          value: this.feeDashboard.summary.todayReceivedAmount,
          className: 'received'
        },
        {
          key: 'receivableAmount',
          label: 'receivable',
          value: this.feeDashboard.summary.receivableAmount,
          className: 'receivable'
        },
        {
          key: 'unreceivedAmount',
          label: 'unreceived',
          value: this.feeDashboard.summary.unreceivedAmount,
          className: 'unreceived'
        }
      ]
    },
    feeItems() {
      const serverItems = this.feeDashboard.feeItems || []
      return this.defaultFeeItems.map(item => {
        const matchedItem = serverItems.find(serverItem => serverItem.key === item.key) || {}
        return Object.assign({
          receivableAmount: 0,
          unreceivedAmount: 0,
          todayReceivedAmount: 0
        }, item, matchedItem)
      })
    }
  },
  methods: {
    async _loadFeeDashboardIndex() {
      const param = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }

      try {
        const res = await getFeeDashboardIndex(param)
        if (res.code === 0 && res.data) {
          Object.assign(this.feeDashboard, res.data)
        }
      } catch (error) {
        console.error('请求收费看板失败', error)
      }
    },
     formatAmount(amount) {
      const value = Number(amount || 0)
      return value.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
       })
     },
     formatPercent(percent) {
       return `${Number(percent || 0).toFixed(2)}%`
     }
  }
}
</script>

<style lang="scss" scoped>
.fee-dashboard-container {
  border-radius: 4px;
  padding: 15px;

  .index-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;

    .month-label {
      font-size: 12px;
      color: #999;
      font-weight: normal;
    }
  }

  .summary-row {
    margin-bottom: 12px;
  }

  .summary-card {
    border-radius: 6px;
    padding: 16px 18px;
    margin-bottom: 12px;
    background: #f7f9fc;

    .summary-label {
      font-size: 13px;
      color: #666;
      margin-bottom: 10px;
    }

    .summary-amount {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    &.received {
      background: #f0f9eb;
    }

    &.receivable {
      background: #ecf5ff;
    }

    &.unreceived {
      background: #fef0f0;
    }
  }

  .fee-item-card {
    min-height: 150px;
    border: 1px solid #edf0f5;
    border-radius: 6px;
    padding: 16px 10px;
    margin-bottom: 12px;
    text-align: center;
    background: #fff;

    .fee-item-icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin: 0 auto 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f0f7ff;

      i {
        color: #409eff;
        font-size: 18px;
      }
    }

    .fee-item-name {
      font-size: 13px;
      color: #666;
      margin-bottom: 8px;
    }

    .fee-item-amount {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 8px;
    }

    .fee-item-desc {
      font-size: 12px;
      color: #999;
    }

    .fee-item-percent {
      font-size: 12px;
      color: #409eff;
      margin-bottom: 8px;
    }
  }
}
</style>
